import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import s from "./SimpleDialog.module.scss";
import TextMAS from "components/TextMAS/TextMAS";
import ButtonMAS from "ButtonMAS/ButtonMAS";

const SimpleDialog = ({
  open,
  dialogOncloseFn,
  title,
  noTitle,
  content,
  confirmFn,
  cancelFn,
  negativeAction,
  negativeActionDisabled,
  negativeActionLoading,
  positiveAction,
  positiveActionDisabled,
  positiveActionLoading,
  maxWidth,
}) => {
  return (
    <Dialog
      open={open}
      slotProps={{
        backdrop: {
          sx: { backgroundColor: "transparent" },
        },
      }}
      PaperProps={{
        sx: { borderRadius: "8px", padding: "0px" },
      }}
      fullWidth
      maxWidth={maxWidth ?? "md"}
    >
      {!noTitle && (
        <DialogTitle
          id="scroll-dialog-title"
          sx={{ "&.MuiDialogTitle-root": { padding: "0 12px 0 24px" } }}
          className={s.dialogHeaderContainer}
        >
          <span className={s.dialogTitle}>{title}</span>
          <ButtonMAS
            variant="text-only"
            className={s.dialogCloseButton}
            aria-label="close"
            onClick={dialogOncloseFn}
            disabled={negativeActionLoading || positiveActionLoading}
          >
            <CloseIcon />
          </ButtonMAS>
        </DialogTitle>
      )}
      <DialogContent
        sx={{
          "&.MuiDialogContent-root": {
            padding: !noTitle ? "24px" : "24px 32px",
            paddingBottom: "0px",
          },
        }}
      >
        <div className={s.dialogBody}>
          {typeof content !== "string" ? content : <TextMAS>{content}</TextMAS>}
        </div>
      </DialogContent>
      <DialogActions
        sx={{ padding: !noTitle ? "24px" : "24px 32px", paddingTop: "24px" }}
      >
        <div className={s.dialogAction}>
          {negativeAction && (
            <ButtonMAS
              size="dialog-button"
              variant="secondary"
              disabled={negativeActionDisabled || negativeActionLoading}
              isLoading={negativeActionLoading}
              onClick={cancelFn || dialogOncloseFn}
            >
              {negativeAction}
            </ButtonMAS>
          )}
          {positiveAction && (
            <ButtonMAS
              size="dialog-button"
              disabled={positiveActionDisabled || positiveActionLoading}
              isLoading={positiveActionLoading}
              onClick={confirmFn}
            >
              {positiveAction}
            </ButtonMAS>
          )}
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(SimpleDialog);
